import { withTransaction } from '@elastic/apm-rum-react'
import { Campaign, HubCampaignsService, LogService, ScheduleItem, UserInDetails } from '@hub/shared'
import { SqLoader } from '@squidit/react-css'
import CampaignCalendarComponent from '@src/components/campaign-calendar/campaign-calendar.component'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

interface ScheduleProps extends React.HTMLAttributes<HTMLDivElement> {
  campaign: Campaign
  userInCampaign: UserInDetails
}

const ScheduleItemsComponent = ({ campaign, userInCampaign }: ScheduleProps) => {
  const [t] = useTranslation('campaignContentOrientation')
  const logService = useMemo(() => new LogService(), [])
  const [scheduleItems, setScheduleItems] = useState<Array<ScheduleItem>>([])
  const hubCampaignsService = useMemo(() => new HubCampaignsService(), [])
  const [loadingScheduleItems, setLoadingScheduleItems] = useState(false)

  const getScheduleItems = useCallback(async () => {
    setLoadingScheduleItems(true)
    try {
      const response = await hubCampaignsService.getSchedules(campaign?._id, userInCampaign?.squidId)

      setScheduleItems(response)
      setLoadingScheduleItems(false)
    } catch (error) {
      setLoadingScheduleItems(false)
      logService.error({ message: 'Failed to get Schedule Items', error })
    } finally {
      setLoadingScheduleItems(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scheduleItems])

  useEffect(() => {
    getScheduleItems()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (loadingScheduleItems) {
    return (
      <div className="display-flex justify-content-center">
        <SqLoader size="big" />
      </div>
    )
  }
  if (!scheduleItems.length) {
    return null
  }
  return (
    <div>
      <h5>{t('postingSchedule')}</h5>
      {scheduleItems?.map((item) => (
        <CampaignCalendarComponent
          className="mb-4"
          key={`${item.date}`}
          campaignSchedule={item}
          socialNetwork={campaign?.socialNetworks[0]}
        ></CampaignCalendarComponent>
      ))}
    </div>
  )
}

export default withTransaction('ScheduleItemsComponent', 'component')(ScheduleItemsComponent)
